export default __webpack_public_path__ + "static/media/CDC_it.caaaff63.svg";